export default class FilterJobScheduleRequest {
    from: string;
    //to: string;
    branchId: string;
    deskId: string;
    companyId: string;
    locationId: string;
    workerId: string;
    jobId: string;

}